import { lazy } from "react";
import { Route, Routes as RouterRoutes } from "react-router-dom";
import { ProtectedLayout } from "@/components/layout/navigation";
import { PrivateRoute } from "./private-route";

const Dashboard = lazy(() => import("@/pages/dashboard"));
const Employees = lazy(() => import("@/pages/employees"));
const Policies = lazy(() => import("@/pages/policies"));
const PolicyDetail = lazy(() => import("@/pages/policies/detail"));
const MemberDetail = lazy(() => import("@/pages/policies/member-detail"));
const BenefitStructure = lazy(() => import("@/pages/policies/benefits"));
// const Settings = lazy(() => import("@/pages/settings"));

const Login = lazy(() => import("../pages/login"));
const NotFound = lazy(() => import("../pages/404"));

export function Routes() {
  return (
    <RouterRoutes>
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<PrivateRoute />}>
        <Route element={<ProtectedLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="members" element={<Employees />} />
          <Route path="policies" element={<Policies />} />
          <Route path="policies/:id" element={<PolicyDetail />} />
          <Route path="policies/:id/member/:memberId" element={<MemberDetail />} />
          <Route path="policies/:id/benefits" element={<BenefitStructure />} />
          {/* <Route path="settings" element={<Settings />} /> */}
        </Route>
        <Route path="*" element={<NotFound />} />
      </Route>
    </RouterRoutes>
  );
}
